(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('[data-form-id]');

  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      console.log('Form submitted:', this.getAttribute('id'));

      // Don't prevent default for normal Shopify forms
      // Only prevent default for AJAX forms
      if (this.getAttribute('data-ajax-form') === 'true') {
        e.preventDefault();
      }

      // Gather all form data
      const formData = new FormData(this);
      const formFields = {};

      for (const [key, value] of formData.entries()) {
        formFields[key] = value;
      }

      // Create and dispatch a custom event with the form data
      const formSubmitEvent = new CustomEvent('formSubmitted', {
        detail: {
          formId: this.getAttribute('id'),
          formName: this.getAttribute('name'),
          formType: this.getAttribute('data-form-type'),
          formFields: formFields
        },
        bubbles: true
      });

      window.dispatchEvent(formSubmitEvent);
      console.log('Form event dispatched:', formSubmitEvent.detail);
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
